<template>
  <dashboardPage />
</template>

<script>

import dashboardPage from './components/dashboardPage.vue';

export default {
  name: 'App',
  components: {
    dashboardPage,
  }
}
</script>

